import { IACDLEvent } from '../../../../../services/eventBus.service';
import { ISegmentation } from '../../../annotations.interface';

export const SegmentationSelectedEventType = Symbol('SEGMENTATION_SELECTED_EVENT');

export class SegmentationSelectedEvent implements IACDLEvent {
  private _selectedSegmentationFeatureId: string;
  get selectedSegmentationFeatureId(): string {
    return this._selectedSegmentationFeatureId;
  }

  constructor(segmentation: ISegmentation) {
    this._selectedSegmentationFeatureId = segmentation.feature.id;
  }

  get type(): symbol {
    return SegmentationSelectedEventType;
  }
}
